// extracted by mini-css-extract-plugin
export default {"customs":"Customs_customs__4Grxc","currencyDropdown":"Customs_currencyDropdown__VxdEF","customsValueInput":"Customs_customsValueInput__TerZC"};